import { render, staticRenderFns } from "./Checbox.vue?vue&type=template&id=2789b1e5&"
import script from "./Checbox.vue?vue&type=script&lang=js&"
export * from "./Checbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports